// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-thumbnail {
  width: 100%;
  border-radius: 10px;
  height: auto;
  object-position: center;
  object-fit: contain;
}

.image-container {
  border-radius: 16px;
  overflow: hidden;
  display: grid;
  place-content: center;
  aspect-ratio: 16/9;
}

.close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  cursor: pointer;
  color: var(--text-color);
  font-size: 0.8rem;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  display: grid;
  place-items: center;
  border: 1px solid var(--surface-background);
  background: var(--surface-ground-60);
}
.close-button i {
  line-height: initial;
}
.close-button:hover {
  color: var(--primary-color);
  background: var(--surface-ground);
}

.swiper-container {
  max-width: 80%;
  margin-inline: 0;
  padding-bottom: 2rem;
}

a {
  text-decoration: none;
  color: var(--text-color);
}
a:hover {
  color: var(--primary-color);
  font-weight: bold;
}

.video-title {
  margin-top: 10px;
  font-size: 1rem;
  white-space: normal;
}

.swiper-pagination {
  width: 120%;
}

:host ::ng-deep .swiper-pagination-bullet {
  width: 1rem;
  border-radius: 8px;
  background: white;
  height: 6px;
  transition: width 0.2s ease-in;
}

:host ::ng-deep .swiper-pagination {
  bottom: 0 !important;
}
:host ::ng-deep .swiper-pagination-bullet-active {
  transition: width 0.2s ease-in;
  background: var(--primary-color);
  width: 5rem;
  border-radius: 8px;
  height: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/youtube-last-videos-carousel/youtube-last-videos-carousel.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,oCAAA;AACF;AACE;EACE,oBAAA;AACJ;AAEE;EACE,2BAAA;EACA,iCAAA;AAAJ;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,oBAAA;AADF;;AAIA;EACE,qBAAA;EACA,wBAAA;AADF;AAGE;EACE,2BAAA;EACA,iBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,8BAAA;AAFF;;AAME;EACE,oBAAA;AAHJ;AAME;EACE,8BAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAJJ","sourcesContent":[".video-thumbnail {\r\n  width: 100%;\r\n  border-radius: 10px;\r\n  height: auto;\r\n  object-position: center;\r\n  object-fit: contain;\r\n}\r\n\r\n.image-container {\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  display: grid;\r\n  place-content: center;\r\n  aspect-ratio: 16 / 9;\r\n}\r\n\r\n.close-button {\r\n  position: absolute;\r\n  top: 0.5rem;\r\n  right: 0.5rem;\r\n  cursor: pointer;\r\n  color: var(--text-color);\r\n  font-size: 0.8rem;\r\n  border-radius: 50%;\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  display: grid;\r\n  place-items: center;\r\n  border: 1px solid var(--surface-background);\r\n  background: var(--surface-ground-60);\r\n\r\n  i {\r\n    line-height: initial;\r\n  }\r\n\r\n  &:hover {\r\n    color: var(--primary-color);\r\n    background: var(--surface-ground);\r\n  }\r\n}\r\n\r\n.swiper-container {\r\n  max-width: 80%;\r\n  margin-inline: 0;\r\n  padding-bottom: 2rem;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: var(--text-color);\r\n\r\n  &:hover {\r\n    color: var(--primary-color);\r\n    font-weight: bold;\r\n  }\r\n}\r\n\r\n.video-title {\r\n  margin-top: 10px;\r\n  font-size: 1rem;\r\n  white-space: normal;\r\n}\r\n\r\n.swiper-pagination {\r\n  width: 120%;\r\n}\r\n\r\n:host ::ng-deep .swiper-pagination-bullet {\r\n  width: 1rem;\r\n  border-radius: 8px;\r\n  background: white;\r\n  height: 6px;\r\n  transition: width 0.2s ease-in;\r\n}\r\n\r\n:host ::ng-deep {\r\n  .swiper-pagination {\r\n    bottom: 0 !important;\r\n  }\r\n\r\n  .swiper-pagination-bullet-active {\r\n    transition: width 0.2s ease-in;\r\n    background: var(--primary-color);\r\n    width: 5rem;\r\n    border-radius: 8px;\r\n    height: 6px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
